import { Children, type ReactNode } from 'react';

import { isSlot } from '../../../core/utils/is-slot.js';
import type { TrendProps } from '../../core/components/single-value-renderer/components/trend/types/trend-props.js';
import type { SparklineDisplayProps } from '../../core/components/sparkline-display/SparklineDisplay.js';
import { iterateSparklineSlots } from '../../core/components/sparkline-display/utils/iterate-sparkline-slots.js';
import { Sparkline } from '../slots/Sparkline.js';
import { Trend } from '../slots/Trend.js';

export interface SingleValueSlots {
  sparkline?: SparklineDisplayProps;
  trend?: TrendProps;
}

export const iterateSlots = (
  children: ReactNode,
): { slots: SingleValueSlots; sparklineChildren: ReactNode } => {
  const slots: SingleValueSlots = {};
  let sparklineChildren: ReactNode;

  Children.forEach(children, (child) => {
    if (isSlot(child, Sparkline)) {
      const { children: sparklineSlots, ...props } = child.props;
      const { thresholds, xAxis, yAxis } =
        iterateSparklineSlots(sparklineSlots);

      slots.sparkline = {
        ...props,
        ...(thresholds.length > 0 ? { thresholds } : {}),
        xAxis,
        yAxis,
      };
      sparklineChildren = sparklineSlots;
    } else if (isSlot(child, Trend)) {
      slots.trend = {
        ...child.props,
      };
    }
  });

  return { slots, sparklineChildren };
};
